import React from 'react';
import { UserPlusIcon, ChevronRightIcon, MessageSquareIcon } from 'lucide-react';
const suggestedConnections = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'Data Scientist @ Intel',
  matchPercentage: 95,
  mutualConnections: 12,
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchReason: 'Interessi comuni in AI e Machine Learning, background simile in Data Science'
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'ML Engineer @ Google',
  matchPercentage: 88,
  mutualConnections: 8,
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchReason: 'Competenze complementari in Deep Learning e Computer Vision'
}];
const MatchConnectWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-558">
      <div className="p-4 flex items-center justify-between" data-id="element-559">
        <div className="flex items-center" data-id="element-560">
          <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-pink-500 mr-2" data-id="element-561">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-562" />
          </div>
          <div data-id="element-563">
            <h2 className="text-base font-semibold text-gray-800" data-id="element-564">
              Match & Connect
            </h2>
            <p className="text-xs text-gray-500" data-id="element-565">
              Powered by EIIS Intelligence
            </p>
          </div>
        </div>
        <button className="text-sm text-gray-500 hover:text-gray-700 flex items-center" data-id="element-566">
          Vedi tutti <ChevronRightIcon size={16} className="ml-1" data-id="element-567" />
        </button>
      </div>
      <div className="p-4" data-id="element-568">
        <div className="space-y-4" data-id="element-569">
          {suggestedConnections.map(connection => <div key={connection.id} className="border border-gray-200 rounded-lg p-3" data-id="element-570">
              <div className="flex items-center justify-between mb-2" data-id="element-571">
                <div className="flex items-center" data-id="element-572">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-3" data-id="element-573">
                    <img src={connection.avatar} alt={connection.name} className="w-full h-full object-cover" data-id="element-574" />
                  </div>
                  <div data-id="element-575">
                    <h3 className="font-medium text-gray-800" data-id="element-576">
                      {connection.name}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-577">{connection.role}</p>
                    <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-578">
                      <span className="text-custom-green font-medium" data-id="element-579">
                        {connection.matchPercentage}% match
                      </span>
                      <span className="mx-1" data-id="element-580">•</span>
                      <span data-id="element-581">
                        {connection.mutualConnections} connessioni in comune
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-582">
                  <button className="p-2 bg-custom-green text-white rounded-full hover:bg-custom-green/90" data-id="element-583">
                    <UserPlusIcon size={16} data-id="element-584" />
                  </button>
                  <button className="p-2 bg-gray-100 text-gray-600 rounded-full hover:bg-gray-200" data-id="element-585">
                    <MessageSquareIcon size={16} data-id="element-586" />
                  </button>
                </div>
              </div>
              <div className="text-xs text-gray-600 bg-gray-50 p-2 rounded-md" data-id="element-587">
                <p data-id="element-588">{connection.matchReason}</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default MatchConnectWidget;